<template>
  <div class="menu-side-wrap">
    <div class="top-wrap">
      <a-button
        v-for="item in topBtnList"
        :key="item.key"
        :class="[item.key === currentSide ? 'active' : 'noActive']"
        @click="sideChange(item.key)">{{item.title}}</a-button>
    </div>
    <component class="component" :is="currentSide" v-bind="$attrs" v-on="$listeners"></component>
    <div class="footer-wrap" v-if="currentSide === 'filterItem'">
      <a-button @click="emitEvent('filter')">筛选</a-button>
      <a-button @click="emitEvent('exclude')">排除</a-button>
    </div>
  </div>
</template>

<script>
import Company from './components/Company'
import FilterItem from './components/FilterItem'

export default {
  data() {
    return {
      topBtnList: [
        { title: '企业名录', key: 'company', component: 'company' },
        { title: '筛选', key: 'filterItem', component: 'filterItem' }
      ],
      currentSide: 'company'
    }
  },
  components: {
    Company,
    FilterItem
  },
  methods: {
    sideChange(key) {
      this.currentSide = key
      this.$emit('resetConfig')
    },
    emitEvent(event) {
      this.$emit(event)
    }
  }
}
</script>
